export const MOTIVOS_CORRECAO = [
  { value: "categoria_servico_incorreta", label: "Categoria de serviço lançada incorreta" },
  { value: "valor_nota_incompativel", label: "Valor da nota incompatível" },
  { value: "valor_custo_receber_incorreto", label: "Valor de custo a receber incorreto" },
  { value: "outro", label: "Outro" },
];
